/**
 * Entertainment hub data source: `ers` (legacy) or `payload` (pg-payload-cms).
 * @returns {'ers' | 'payload'}
 */
export function getEntertainmentSource() {
  const raw = process.env.REACT_APP_PROMOTIONS_SOURCE || "ers";
  const source = raw.split("#")[0].trim().toLowerCase();
  return source === "payload" ? "payload" : "ers";
}

export function isPayloadEntertainmentSource() {
  return getEntertainmentSource() === "payload";
}
